import { Container, TextField, Box } from "@mui/material";
import React from "react";

export const AliasInfo: React.FC<any> = ({ aliases, applicantAliasFieldsMap }) => {

    if (!aliases || aliases.length === 0) {
        aliases.push({
            "firstName": "",
            "middleName": "",
            "lastName": "",
            "suffix": ""
        });
    }

    return (
        <Container disableGutters maxWidth={false} sx={{ marginTop: "12px", marginBottom: "24px", width: "100%" }}>
            <Box display="flex" flexDirection="column" gap={2}>
                {aliases.slice(0, 5).map((alias) => (
                    <Box
                        key={alias}
                        display="flex"
                        gap={2}
                        flexWrap="wrap"
                        alignItems="center"
                    >
                        {
                            Object.entries(alias).map(([key, value]) => {
                                const config = applicantAliasFieldsMap[key];

                                return (
                                    <TextField
                                        key={`${alias}-${key}`}
                                        disabled
                                        sx={{
                                            flexBasis: config.size,
                                            flexGrow: 1,
                                            maxWidth: config.maxWidth
                                        }}
                                        value={value}
                                        label={config.label}
                                        placeholder={config.placeholder}
                                    />
                                )
                            }
                            )}
                    </Box>
                ))}
            </Box>
        </Container>
    )
}